import { type Resource } from './types'

export function mergeScopes(permissions: Resource[]): string[] {
  return permissions
    .map(permission => permission.scopes)
    .flat()
    .map(scope => scope.name)
}
